exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-check[data-v-728b1e0c] {\n  width: 24%;\n  text-align: center;\n  cursor: pointer;\n}\n.radio-check .text[data-v-728b1e0c] {\n  display: block;\n  padding-top: 10px;\n}\ninput[type=\"radio\"][data-v-728b1e0c] {\n  display: none;\n}\n@media (max-width: 767px) {\n.radio-check[data-v-728b1e0c] {\n    width: 100%;\n}\n}\n", ""]);

// exports
